import React from "react"

import { itsmType } from "./Constants"
export const accountSelect = (
  <p>
    Choose the account you would like to see detailed information about
    (multiple accounts may be selected).
  </p>
)
export const feedbackDrawerText = (
  <>
    <p>
      <b>Please note:</b>{" "}
      {
        "Survey cannot be submitted anonymously if response is requested back from CMS Team."
      }
    </p>
  </>
)

export const datadogTooltip = (
  <>
    <p>SAP resources can access the Avantra through CISCO Client VPN.</p>
    <p>Only Deloitte resources will have to access Avantra through F5 VPN.</p>
  </>
)

export const serviceRequestText =
  "Create an Incident record to report and request assistance with an issue you are having"
export const notificationTooltipText = (
  <p>
    <b>Approvals</b> - Approvals currently awaiting your review.
    <br />
    <b>Change Requests</b> - Change Requests submitted by you.
    <br />
    <b>RITM</b> - Request Items submitted by you.
  </p>
)

export const itsmTabTooltips = {
  [itsmType.INC]: (
    <>
      <p>(Data is displayed based on the above selected timeframe)</p>
      <p>
        <b>Open Incidents:</b>
      </p>
      <p>All Incident tickets not closed or resolved.</p>
      <p>
        <b>Resolved Incidents:</b>
      </p>
      <p>All Incident tickets that are either closed or resolved.</p>
      <p>Clicking on the drawer will take you to the ServiceNow native tool.</p>
    </>
  ),
  [itsmType.CHG]: (
    <>
      <p>(Data is displayed based on the above selected timeframe)</p>
      <p>
        <b>Open Change Requests:</b>
      </p>
      <p>All Change Requests tickets not closed or resolved.</p>
      <p>
        <b>Resolved Change Requests:</b>
      </p>
      <p>All Change Requests that are resolved.</p>
      <p>Clicking on the drawer will take you to the ServiceNow native tool.</p>
    </>
  ),
  [itsmType.SEV]: (
    <>
      <p>(Data is displayed based on the above selected timeframe)</p>
      <p>
        <b>Open Service Requests:</b>
      </p>
      <p>All Service Requests tickets not closed or resolved.</p>
      <p>
        <b>Resolved Service Requests:</b>
      </p>
      <p>All Service Requests that are resolved.</p>
      <p>Clicking on the drawer will take you to the ServiceNow native tool.</p>
    </>
  )
}

export const dateRangeFilterTooltip =
  "Select a pre-defined period or custom period from the calendar."
export const vmInvTooltip = (
  <p>Click on Pie Chart Wedges in order to filter data set.</p>
)
export const cmsReportsTooltip = (
  <>
    <p>
      Search for and download reports <br />
      shared by Deloitte in this shared <br />
      repository.
    </p>
    <p>
      <b>
        Note that only Deloitte team <br /> members can upload files.
      </b>
    </p>
  </>
)
export const prismaCloudTooltip = (
  <p>Click Cards or Doughnut Chart to see additional details.</p>
)
export const topResourcesTooltip =
  "CSP Spend for upto 5 resources by current month and previous month"
export const totalSpendTooltip = (
  <p>
    This chart denotes total spend for the previous month, current month and
    forecasted amount for the current month. The forecasted amount is based on
    the previous month&apos;s spend and is only an estimate.
  </p>
)
export const serviceSpendTooltip =
  "Choose to view current or previous month in the dropdown to the right. Click on the graph or the table column headers to filter and refine your view."
export const spendThisMonthTooltip =
  "Below chart gives a Cloud Service Provider cost breakdown of the accounts."
export const complaintToolTip = (
  <>
    <p>- Datadog agent must be installed on the VM</p>
    <p>- Datadog agent must be running on an approved version</p>
    <p>- Datadog must be integrated to the CSP Account</p>
    <p>
      - The VM must be tagged with the &#39;account_id&#39; and
      &#39;client_name&#39; tags
    </p>
  </>
)
export const securityComplianceTooltip = (
  <>
    <p>
      - Clickable Chart represents Compliant versus Non-Compliant OS
      Vulnerabilities per Account.
      <br />- By clicking on the Bar Chart, you will be taken to the Security
      and Compliance detail page.
    </p>
    <br />
    <p>
      <b>Please note: </b> Vulnerability becomes non-compliant when its deadline
      to fix is missed unless it has an approved Change Request Exception from
      Project Sponsor Deadline to fix OS vulnerabilities: Critical & High –&gt;
      30 days | Medium –&gt; 60 days
    </p>
  </>
)
export const userReviewSummaryTooltip =
  "All users with access to one or more tools are listed here. Users must be certified during the defined certification window. Note that only qualified users can complete the certification. Users cannot certify themselves."
export const uarPodAccessTypeTooltip = (
  <div className="uarPodAccessTooltip">
    <p className="font-weight-bold">
      Users may have access to one or more of the following tools:
    </p>
    <p>
      <span>ASA</span>: Okta Advanced Server Access
    </p>
    <p>
      <span>AVANTRA</span>: Infrastructure monitoring{" "}
    </p>
    <p>
      <span>AWS</span>: Amazon Web Services
    </p>
    <p>
      <span>AWX</span>: Ansible Tower{" "}
    </p>
    <p>
      <span>AZURE</span>: Azure
    </p>
    <p>
      <span>DATADOG</span>: Infrastructure monitoring
    </p>
    <p>
      <span>GCP</span>: Google Cloud Platform
    </p>
    <p>
      <span>JENKINS</span>: the user has access to Jenkins for the project
    </p>
    <p>
      <span>OCI</span>: Oracle Cloud
    </p>
    {/* <p>
      <span>RULE</span>
    </p> */}
    <p>
      <span>SERVICENOW</span>: ServiceNow login
    </p>
    <p>
      <span>SSO</span>: Single Sign On to the cloud service provider
    </p>
    {/* <p>
      <span>USERS</span>
    </p> */}
    <p>
      <span>VAULT</span>: HashiCorp Vault Secrets Manager
    </p>
    <p>
      <span>VPN</span>: Virtual Private Network
    </p>
  </div>
)
export const uarProjAccessTypeTooltip = (
  <div className="uarPodAccessTooltip">
    <p className="font-weight-bold">
      Users may have access to one or more of the following tools:
    </p>
    <p>
      <span>ASA</span>: Okta Advanced Server Access{" "}
    </p>
    <p>
      <span>AVANTRA</span>: Infrastructure monitoring{" "}
    </p>
    <p>
      <span>CLIENTPORTAL</span>: OpenCloud Client Portal{" "}
    </p>
    <p>
      <span>DATADOG</span>: Infrastructure monitoring
    </p>
    <p>
      <span>SERVICENOW</span>: ServiceNow login
    </p>
    <p>
      <span>SSO</span>: Single Sign On to the cloud service provider
    </p>
    <p>
      <span>VAULT</span>: HashiCorp Vault Secrets Manager
    </p>
    <p>
      <span>VPN</span>: Virtual Private Network
    </p>
  </div>
)

export const inventoryStatusTooltip = (
  <p>Click on Pie Chart Wedges in order to filter data set.</p>
)
export const vmTaggingTooltip = (
  <p>
    Click on the pie chart wedges to filter data. You can also type a VM tag in
    the search bar to see Key:Value pairs.
  </p>
)
export const keyRotationTooltip = (
  <>
    <p>
      OpenCloud policy requires AWS secret access keys to be rotated every 90
      days. Beyond 90 days is considered non compliant.
    </p>
    <p>Click Cards or Pie Chart to see additional details.</p>
  </>
)
export const incidentBreakdownTooltip = (
  <>
    <p>
      <strong>Availability</strong> - Network
    </p>
    <p>
      <strong>Performance</strong> - Server
    </p>
    <p>
      <strong>Security</strong> - Security
    </p>
    <p>
      <strong>Compliance</strong> - Risk Management
    </p>
    <p>
      <strong>Miscellaneous</strong> - All other Incidents not conforming to
      above categories.
    </p>
  </>
)
export const serviceRequestBreakdownTooltip = <></>
export const crBreakdownTooltip = (
  <>
    <p>
      <strong>Access Management </strong> - User Access Control, Active
      Directory, Servicenow
    </p>
    <p>
      <strong>Infrastructure Requests</strong> -Network, Server, Environment
    </p>
    <p>
      <strong>Security</strong> - Security
    </p>
    <p>
      <strong>Patching</strong> - Patching
    </p>
    <p>
      <strong>Miscellaneous</strong> - All other Requests not conforming to
      above categories.
    </p>
  </>
)
export const antiMalwareTooltip =
  "A compliant host is one that has the anti malware agent installed, with an active 'pulse/ping' from the agent to the console within a recent period of time, without warning/errors being caught by the SaaS console."
export const securityIncidentsTooltip =
  "Displays Total, Open and Closed Incidents assigned to Security Category by time period selected from the drop down."
export const vulnerabilityComplianceTooltip = (
  <>
    <p>
      {
        "- From the below Donut Chart, select between Critical, High and Medium Vulnerabilities."
      }
    </p>
    <p>
      {
        "- Clicking on the pie sections will display more detailed information in the right pane. "
      }
    </p>
  </>
)

export const projectSelectTooltip = (selectedItem) => {
  return selectedItem
    ? `${selectedItem.text} - ${selectedItem.key}`
    : "No Project Selected"
}

export const infraMonitoringNonSafariInfo = [
  <>
    <li>
      To view dashboards, enable <b>Third-party Cookies</b> in your browser
      settings
    </li>
  </>
]

export const infraMonitoringSafariInfo = [
  <>
    <li>
      To view dashboards, go to{" "}
      <b>
        {" "}
        Safari {">"} Preferences {">"} Privacy{" "}
      </b>{" "}
      and turn off both <b> Prevent cross-site tracking</b> and{" "}
      <b>Block all cookies.</b>
    </li>
  </>
]

export const welcomeBannerInfo = [
  <li key="wb-info-0">
    This portal provides you with key information regarding your{" "}
    <b>Hybrid Cloud Managed Services</b>.
  </li>,
  <li key="wb-info-1">
    Please check the Bell Icon in the upper right hand corner for any open
    Service Requests.
  </li>
]

export const welcomeBannerTitle = "Welcome to the Insight Management Portal"
export const userReviewBannerTitle = "Welcome to the User Access Review page"

export const inframonitoringBannerTitle =
  "Welcome to Infra Monitoring Dashboards"

export const notApplicable = "NA"
export const unknown = "Unknown"

export const betaBannerInfo = [
  <li key="wb-info-0">
    This feature is currently in <b>Beta</b>
  </li>
]

export const vmBackupBannerInfo = [
  ...betaBannerInfo,
  <li key="wb-info-0">
    Please note that tags need to be applied to servers to accurately track
    backup status
  </li>
]

export const vmBackupTitle = "VM Backup"

export const fixedVulTooltip = (
  <>
    <p>
      - This graph displays vulnerabilities from the last (rolling) 30 days that
      are resolved and no longer present.
    </p>
    <p>
      - Clicking on the graph or legend will filter the data by severity across
      Accounts.
    </p>
  </>
)

export const defaultFlashMessage =
  "This is a sample message. You can use optional date tags like {startDate} or {endDate} to include dates in the message. You can see a preview of your message below."

export const pageNames = {
  "Overall Analytics": "/",
  "IT Service Management": "/service",
  "Security and Compliance": "/security",
  "Infra Monitoring": "/infra-monitoring",
  "VM Inventory": "/vm-inventory",
  "User Access Review": "/user-review",
  "CMS Reports": "/resources",
  Secrets: "/secrets",
  "Client Dashboard": "/client-dashboards",
  Feedback: "/admin",
  "Application Monitoring": "/admin/application-monitoring",
  Maintenance: "/admin/maintenance",
  "CMS Users": "/cms",
  "Canned Reports": "/canned-reports",
  "Datadog Agent Compliance": "/pod-datadog-compliance",
  "Pod VM Inventory": "/pod-vm-inventory",
  "Pod User Access Review": "/pod-user-access",
  "Zero Day Patch Vulnerabilities": "/pod-zero-day-vulnerabilities",
  "Pod Health Assessment": "/pod-health-assessment",
  Dashboards: "/dashboards"
}

export const invalidInterval = "Please enter a valid interval."
export const overlappingInterval =
  "Overlapping among the intervals is not allowed."
